import { fetchUserAnalyticsDaily } from "./fetchUserAnalyticsDaily";
import { useUserAnalyticsDateRangeQuery } from "./useUserAnalyticsDateRangeQuery";
import type {
  UserAnalyticsDailyQueryParams,
  UserAnalyticsDailyResult,
} from "./userAnalyticsDailyTypes";

export const USER_ANALYTICS_DAILY_QUERY_KEY = "USER_ANALYTICS_DAILY" as const;

/**
 * Loads the per-day signups / FTDs / FTD-amount breakdown for the Acquisition
 * tab's chart. The query key incorporates the date range so the cache
 * invalidates whenever the user picks a new window. Mirrors the staleness /
 * focus behaviour of `useUserAnalyticsKpis`.
 */
export function useUserAnalyticsDaily(params: UserAnalyticsDailyQueryParams) {
  return useUserAnalyticsDateRangeQuery<UserAnalyticsDailyResult>(
    USER_ANALYTICS_DAILY_QUERY_KEY,
    params,
    () => fetchUserAnalyticsDaily(params),
  );
}
